<template>
    <div class="chart" >
        <div :id="id" :option="option"  :style="{width: width, height: height}"></div>
    </div>
</template>

<script>
    export default {
      // 验证类型
      data() {
        return {
          eComVisitChart: null,
          pieOption: {
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} '
            },
            calculable: false,
            series: [
              {
                name: '',
                type: 'pie',
                radius: ['50%', '70%'],
                avoidLabelOverlap: false,
                label: {
                  normal: {
                    show: false,
                    position: 'center'
                  },
                  emphasis: {
                    show: true,
                    textStyle: {
                      fontSize: '14',
                      fontWeight: 'normal',
                      color: '#000',
                      backgroundColor: {
                        image: '../../assets/logo.png'
                      }
                    }
                  }
    
                },
                labelLine: {
                  normal: {
                    show: false
                  }
                },
                data: [
                  {
                    value: 0, name: ''
                  },
                  {
                    value: 0, name: ''
                  }
                ]
              }
            ]
          },
          barOption: {
            tooltip: {
              trigger: 'axis',
              axisPointer: { // 坐标轴指示器，坐标轴触发有效
                type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            legend: {
              data: []
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: []
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: '直接访问',
                type: 'bar',
                data: [],
                itemStyle: {
                  color: '#B6A2DE'
                }
              },
              {
                name: '视频广告',
                type: 'bar',
                data: [],
                itemStyle: {
                  color: '#5AB1EF'
                }
              },
              {
                name: '搜索引擎',
                type: 'bar',
                data: [],
                itemStyle: {
                  color: '#FFB980'
                }
              }
            ]
          }
        }
      },
      props: {
        id: {
          type: String
        },
        option: {
          type: Object
        },
        options: {
          type: Array
        },
        width: {
          type: String
        },
        height: {
          type: String
        },
        type: {
          type: Boolean
        },
        isHosp: {
          type: String
        },
        istype: {
          type: Object
        }
      },
      mounted() {
        var vm = this
        this.init()
        this.eComVisitChart.on('click', function(params) {
          if (params.seriesName === '待检查') {
            vm.$router.push({ path: '/screening/index' })
          }
          if (params.seriesName === '待诊断') {
            vm.$router.push({ path: '/diagnostic/index' })
          }
          if (params.seriesName === '待审核') {
            vm.$router.push({ path: '/audit/index' })
          }
        })
      },
      methods: {
        init() {
          var vm = this
          this.eComVisitChart = this.$echarts.init(document.getElementById(this.id))
          window.addEventListener('resize', function() {
            vm.eComVisitChart.resize()
          })
          if (this.type) {
            if (this.isHosp === 'pie1') {
              var arr = []
              for (var i = 0; i < this.options.length; i++) {
                var obj = {
                  name: this.options[i].hospName,
                  value: this.options[i].totalCount
                }
                arr.push(obj)
              }
              this.pieOption.series[0].label.normal.position = 'outside'
              this.pieOption.series[0].label.emphasis.show = false
              this.pieOption.series[0].radius = '55%'
              this.pieOption.series[0].data = arr
              this.eComVisitChart.setOption(this.pieOption)
            } else if (this.isHosp === 'pie2') {
              var arr1 = []
              for (var v = 0; v < this.options.length; v++) {
                var obj1 = {
                  name: this.options[v].modalityName,
                  value: this.options[v].count
                }
                arr1.push(obj1)
              }
              this.pieOption.series[0].label.normal.position = 'outside'
              this.pieOption.series[0].label.emphasis.show = false
              this.pieOption.series[0].radius = '55%'
              this.pieOption.series[0].data = arr1
              this.eComVisitChart.setOption(this.pieOption)
            } else if (this.isHosp === 'pie3') {
              var arr11 = []
              for (var v1 = 0; v1 < this.options.length; v1++) {
                var obj11 = {
                  name: this.options[v1].doctorName,
                  value: this.options[v1].createCount
                }
                arr11.push(obj11)
              }
              this.pieOption.series[0].label.normal.position = 'outside'
              this.pieOption.series[0].label.emphasis.show = false
              this.pieOption.series[0].radius = '55%'
              this.pieOption.series[0].data = arr11
              this.eComVisitChart.setOption(this.pieOption)
            } else if (this.isHosp === 'pie4') {
              var arr111 = []
              for (var v11 = 0; v11 < this.options.length; v11++) {
                var obj111 = {
                  name: this.options[v11].doctorName,
                  value: this.options[v11].firstApproveCount
                }
                arr111.push(obj111)
              }
              this.pieOption.series[0].label.normal.position = 'outside'
              this.pieOption.series[0].label.emphasis.show = false
              this.pieOption.series[0].radius = '55%'
              this.pieOption.series[0].data = arr111
              this.eComVisitChart.setOption(this.pieOption)
            } else {
              this.pieOption.series[0].name = this.option.typeName
              var arr2 = []
              if (this.option.type === 1) {
                if (this.option.totalCount === 0) {
                  arr2 = [{
                    value: this.option.doneCount, name: '已检查', itemStyle: { color: '#B6A2DE' }
                  }]
                } else {
                  arr2 = [{
                    value: this.option.doneCount, name: '已检查', itemStyle: { color: '#B6A2DE' }
                  },
                  {
                    value: this.option.todoCount, name: '剩余检查', itemStyle: { color: '#D4DAE9' }
                  }]
                }
              } else if (this.option.type === 2) {
                if (this.option.totalCount === 0) {
                  arr2 = [{
                    value: this.option.doneCount, name: '已诊断', itemStyle: { color: '#5AB1EF' }
                  }]
                } else {
                  arr2 = [{
                    value: this.option.doneCount, name: '已诊断', itemStyle: { color: '#5AB1EF' }
                  },
                  {
                    value: this.option.todoCount, name: '剩余报告', itemStyle: { color: '#D4DAE9' }
                  }]
                }
              } else if (this.option.type === 3) {
                if (this.option.totalCount === 0) {
                  arr2 = [{
                    value: this.option.doneCount, name: '已审核', itemStyle: { color: '#FFB980' }
                  }]
                } else {
                  arr2 = [{
                    value: this.option.doneCount, name: '已审核', itemStyle: { color: '#FFB980' }
                  },
                  {
                    value: this.option.todoCount, name: '剩余审核', itemStyle: { color: '#D4DAE9' }
                  }]
                }
              }
              this.pieOption.series[0].data = arr2
              this.eComVisitChart.setOption(this.pieOption)
            }
          } else {
            const arr = []
            for (var ii = 0; ii < this.option.sevenDaysList.length; ii++) {
              for (var vv = 0; vv < this.option.sevenDaysList[0].completes.length; vv++) {
                if (this.option.sevenDaysList[0].completes[vv].type === 1) {
                  this.barOption.legend.data.push('已检查')
                  this.barOption.series[0].name = '已检查'
                  this.barOption.series[0].data.push(this.option.sevenDaysList[ii].completes[vv].count)
                }
                if (this.option.sevenDaysList[0].completes[vv].type === 2) {
                  this.barOption.legend.data.push('已诊断')
                  this.barOption.series[1].name = '已诊断'
                  this.barOption.series[1].data.push(this.option.sevenDaysList[ii].completes[vv].count)
                }
                if (this.option.sevenDaysList[0].completes[vv].type === 3) {
                  this.barOption.legend.data.push('已审核')
                  this.barOption.series[2].name = '已审核'
                  this.barOption.series[2].data.push(this.option.sevenDaysList[ii].completes[vv].count)
                }
              }
              // this.barOption.series[0].name = '已检查'
              // this.barOption.series[1].name = '已诊断'
              // this.barOption.series[2].name = '已审核'
              // this.barOption.series[0].data.push(this.option.sevenDaysList[i].completes[0].count)
              // this.barOption.series[1].data.push(this.option.sevenDaysList[i].completes[1].count)
              // this.barOption.series[2].data.push(this.option.sevenDaysList[i].completes[2].count)
              arr.push(this.option.sevenDaysList[ii].date)
            }
            this.barOption.xAxis[0].data = arr
            this.eComVisitChart.setOption(this.barOption)
          }
    
          // _this.eComVisitChart.resize()
        }
      },
      watch: {
        // 观察option的变化
        option: {
          handler(newVal, oldVal) {
            if (this.eComVisitChart) {
              if (newVal) {
                this.eComVisitChart.setOption(newVal)
              } else {
                this.eComVisitChart.setOption(oldVal)
              }
            } else {
              this.init()
            }
          },
          deep: true // 对象内部属性的监听，关键。
        },
        istype: {
          handler(newVal, oldVal) {
            if (this.eComVisitChart) {
              this.init()
            } else {
              this.init()
            }
          },
          deep: true // 对象内部属性的监听，关键。
        }
      },
      beforeDestroy() {
        if (this.eComVisitChart) {
          this.eComVisitChart.clear()
        }
      }
    }
</script>

<style scoped>

</style>